<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';
import RbxDatePicker from '../../../shared/reybex/RbxDatePicker';

export default {
  name: 'AvContractObjectAndDurationForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxDatePicker,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    avContract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'avContract',
    };
  },
  methods: {
    onDateInput(newDate) {
      this.avContract.enddateOfTemporaryTask = newDate;
    },
  },
};
</script>

<template>
  <div class="avContract-detail-tab main-tab">
    <v-layout row wrap>
      <!-- Basic information left column -->
      <v-flex md12 xs12>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.subject')" md6 py-0>
            <v-textarea
              v-model="avContract.subject"
              label="Gegenstand"
              class="caption"
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.type')" md6 py-0>
            <v-radio-group v-model="avContract.type" column>
              <v-radio label="Der Auftrag wird zur einmaligen Ausführung erteilt" :value="0"/>
              <v-radio label="Die Dauer dieses Auftrags ist befristet" :value="1"/>
              <v-radio label="Der Auftrag ist unbefristet erteilt" :value="2" />
              <v-radio
                label="Der Auftrag gilt solange der folgende Hauptvertrag gültig ist"
                :value="3"
              />
            </v-radio-group>
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex
            v-if="isFieldVisible('avContract.enddateOfTemporaryTask')
            && avContract.type == 1"
            md6 py-0
          >
            <rbx-date-picker
              label="Enddatum des befristeten Auftrags"
              :value="avContract.enddateOfTemporaryTask"
              @input="onDateInput" />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex
            v-if="isFieldVisible('avContract.cancellationPriod')
            && avContract.type == 2"
            md6 py-0
          >
            <v-text-field
              v-model="avContract.cancellationPriod"
              label="Kündigungsfrist"
              height="22"
              class="caption"
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.mainContract') && avContract.type == 3" md6 py-0>
            <v-text-field
              v-model="avContract.mainContract"
              label="Hauptvertrag"
              height="22"
              class="caption"
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex
            v-if="isFieldVisible('avContract.otherControlLawMeasures')
            && avContract.type == 1"
            md6 py-0
          >
            <v-text-field
              v-model="avContract.otherControlLawMeasures"
              label="Beschreiben Sie die Maßnahme"
              height="22"
              class="caption"
            />
          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
